import type {User, UserIdentity} from '@supabase/supabase-js';

/**
 * Prefer a user-set CDN avatar_url, then OAuth identity pictures.
 */
export function resolveAccountAvatarUrl(
  user: User | null | undefined,
  identities: UserIdentity[] | null | undefined = [],
): string | undefined {
  const metaUrl = String(user?.user_metadata?.['avatar_url'] || user?.user_metadata?.['picture'] || '')
    .trim();
  if (metaUrl) {
    return metaUrl;
  }

  for (const identity of identities ?? []) {
    const data = identity.identity_data ?? {};
    const url = String(data['avatar_url'] || data['picture'] || '').trim();
    if (url) {
      return url;
    }
  }

  return undefined;
}

/**
 * Supabase standard display name: user_metadata.full_name (OAuth often fills this).
 */
export function resolveAccountFullName(
  user: User | null | undefined,
  identities: UserIdentity[] | null | undefined = [],
): string {
  const meta = user?.user_metadata ?? {};
  const fromMeta = String(meta['full_name'] || meta['name'] || '').trim();
  if (fromMeta) {
    return fromMeta;
  }

  for (const identity of identities ?? []) {
    const data = identity.identity_data ?? {};
    const fromIdentity = String(data['full_name'] || data['name'] || '').trim();
    if (fromIdentity) {
      return fromIdentity;
    }
  }

  return '';
}
